<template>
  <div class="contents">
    <div class="layout">

      <div class="page-top">
        <h2>협업 신청 관리</h2>
        <div class="breadcrumbs">
          <span>운영 관리</span>
          <span class="color-black">협업 신청 관리</span>
        </div>
      </div>

      <div class="white-panel mt30 pt30 pb30">
        <div class="search-panel">
          <table>
            <colgroup>
              <col style="width:150px;">
              <col>
            </colgroup>
            <tbody>
              <tr>
                <th>검색어</th>
                <td>
                  <div class="input-search">
                    <input v-model="searchQuery" @keyup.enter="loadItem" type="text" name="search-input"
                      placeholder="신청자명 입력">
                    <i @click="loadItem" class="button-search" style="cursor: pointer;"><img
                        src="@/assets/images/ico/ico_search.svg" alt="" /></i>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="white-panel mt20">
        <div class="table-wrap">
          <div class="scroll-box">
            <table class="table-type1">
              <colgroup>
                <col style="width:70px;">
                <col style="width:120px;">
                <col style="width:140px;">
                <col style="width:140px;">
                <col>
                <col style="width:120px;">
                <col style="width:140px;">
              </colgroup>
              <thead>
                <tr>
                  <th>NO</th>
                  <th>신청자명</th>
                  <th>연락처</th>
                  <th>기업명</th>
                  <th>관심작가</th>
                  <th>답변 여부</th>
                  <th>등록일</th>
                </tr>
              </thead>
              <tbody ref="tbodyRef">
                <tr v-for="(item, index) in items" :key="item.uuid" :class="{ 'row-completed': item.isAnswered, 'row-pending': !item.isAnswered }">
                  <td>{{ index }}</td>
                  <td>
                    <router-link :to="{ name: 'CollaborationDetail', params: { uuid: item.uuid } }">
                      {{ item.name }}
                    </router-link>
                  </td>
                  <td>{{ item.phoneNum }}</td>
                  <td>{{ item.companyName }}</td>
                  <td>{{ item.interestArtist }}</td>
                  <td>{{ item.isAnswered }}</td>
                  <td>{{ item.createdAt }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { apiClient } from '@/services/auth-header';

const searchQuery = ref('');
const items = ref([]);
const API_URL = '/support';

const loadItem = async () => {
  try {
    const response = await apiClient.get(`${API_URL}/collaborations`, {
      params: { q: searchQuery.value }
    });
    items.value = response.data;
  } catch (error) {
    console.error('Error fetching Collaboration data:', error);
  }
};

onMounted(async () => {
  loadItem();
});

</script>
